import React, { useRef } from 'react';
import './MeetTeam.css';
import joshma from '../Assets/joshma.jpg';
import diksha from '../Assets/diksha.jpg';

import bgimage1 from "../Assets/service1.webp"
import { useNavigate } from 'react-router-dom';

const MeetTeam = () => {
  const scrollContainerRef = useRef(null);
  const navigate= useNavigate()
  const founders = [
    {
      id: 1,
      name: 'Ms. Joshma Choudhury',
      position: 'Founder ',
      image: joshma,
      backgroundImage: bgimage1,
      description: [
        'Ms. Joshma Choudhury is a seasoned professional with a diverse background spanning aviation and special education. She has been associated with British Airways and has extensive experience in Autism Spectrum Disorder (ASD) education.',
        'She holds a Master’s degree in Mass Communication from the University of Culture and has completed multiple diplomas in special education from premier institutes. Her multidisciplinary expertise enables her to bring a unique perspective to both communication and inclusive education.',
      ]
    },
    {
      id: 2,
      name: 'Ms. Diksha Choudhury',
      position: 'Co-Founder ',
      image: diksha,
      backgroundImage: bgimage1,
      description: [
        'Ms. Diksha Choudhury is currently pursuing an Integrated Law Programme at NMIMS University, Mumbai. She is actively involved in assisting the CBGE team in strategic operations across various projects within the legal domain.',
        'Her academic background, combined with hands-on experience in legal and operational work, reflects her strong commitment to building impactful and well-structured initiatives.'
      ]
    }
  ];

  //  const teamMembers = [
  //   {
  //     id: 1,
  //     name: 'Gautam Mohanty',
  //     position: 'Director - EPC ProjectS',
  //     image: team1
  //   },
  //   {
  //     id: 2,
  //     name: 'Suraj Gantayat',
  //     position: 'Chief Technology Officer',
  //     image: team1
  //   },
  //   {
  //     id: 3,
  //     name: 'Subrat Kumar Satpathy',
  //     position: 'Director - Business Development',
  //     image: team1
  //   },
  //   {
  //     id: 4,
  //     name: 'Swapnendu Kabi',
  //     position: 'Director - Operations',
  //     image: team1
  //   }
  // ];

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth / 4 + 30; // One card width + gap
      const targetScroll = direction === 'left' 
        ? container.scrollLeft - scrollAmount 
        : container.scrollLeft + scrollAmount;
      
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="meet-team-section">
      <div className="meet-team-container">
        {/* Header */}
        <div className="meet-team-header">
          <span className="meet-team-badge">Meet the Founders and Team</span>
          <h1 className="meet-team-title" data-aos="fade-up">
            Experts Driving Your <br />
            Project Success
          </h1>
          <p className="meet-team-subtitle" data-aos="fade-up">
            Our team brings together decades of experience in land acquisition, legal compliance, and community engagement to deliver exceptional results.
          </p>
        </div>

        {/* Founders Section */}
        <div className="founders-section">
          {founders.map((founder, index) => (
            <div key={founder.id} className={`founder-card ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
            style={{
                backgroundImage: `url(${founder.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 85%',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <div className="founder-image-wrapper">
                <img 
                  src={founder.image} 
                  alt={founder.name} 
                  className="founder-image"
                />
              </div>
              <div className="founder-content">
                <h3 className="founder-name">{founder.name}</h3>
                <p className="founder-position">{founder.position}</p>
                <div className="founder-description">
                  {founder.description.map((para, index) => (
                    <p key={index} className="founder-para">{para}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Grid Wrapper with Scroll */}
        {/* <div className="meet-team-scroll-wrapper">
          <div 
            className="meet-team-grid"
            ref={scrollContainerRef}
          >
            {teamMembers.map((member) => (
              <div key={member.id} className="meet-team-card" data-aos="fade-up">
                <div className="meet-team-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="meet-team-image"
                    draggable="false"
                  />
                  <div className="meet-team-overlay">
                    <div className="meet-team-info" style={{paddingBottom:"40px"}}>
                      <h3 className="meet-team-name">{member.name}</h3>
                      <p className="meet-team-position">{member.position}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Scroll Buttons */}
        {/* <div className="meet-team-scroll-buttons">
          <button 
            className="meet-team-scroll-btn meet-team-scroll-left"
            onClick={() => scroll('left')}
            aria-label="Scroll left"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button 
            className="meet-team-scroll-btn meet-team-scroll-right"
            onClick={() => scroll('right')}
            aria-label="Scroll right"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div> */}

        {/* CTA Button */}
        {/* <div className="meet-team-cta">
          <button className="cta-btn" onClick={()=>{navigate("/team")}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Meet The Team
        </button>
        </div> */}
      </div>
    </section>
  );
};

export default MeetTeam;